import React, { useEffect, useRef, useState } from "react";
import { Box, FormControl, FormControlLabel, FormGroup } from "@mui/material";
import Checkbox from "../Common/Checkbox";
import { htmlParser } from "../../Utility/constants";
import "./QuestionTypes.scss";

const MultipleChoiceQuestion = (props) => {
  const {
    question,
    fieldConfig,
    onChange,
    value,
    errorIndicator,
    type,
    disabledField,
    renderDependentField,
  } = props;

  const [selectedOptions, setSelectedOptions] = useState([]);

  const [checkOptions, setCheckOptions] = useState([]);

  const [checkOptSave, setCheckOptSave] = useState([]);

  useEffect(() => {
    if (question && question?.fieldValues.length) {
      const columns = [];
      let currentColumn = [];

      question.fieldValues.forEach((item, index) => {
        if (index === 0) {
          currentColumn.push(item);
          return;
        }

        if (item.newColumn) {
          columns.push(currentColumn);
          currentColumn = [];
        }

        currentColumn.push(item);
      });

      if (currentColumn.length > 0) {
        columns.push(currentColumn);
      }

      const optionsArray = columns.flatMap((group, columnIndex) =>
        group.map((item) => ({
          label: item.name,
          value: item.allowableValue,
          isExclusive: item.exclusiveAnswer,
          columnNo: columnIndex,
          historicalAnswer: question?.historicalAnswer?.value,
          dependentField: item.dependentField,
        }))
      );

      setCheckOptions(optionsArray);
    }
  }, [question]);

  const handleChange = (event, option) => {
    if (option.isExclusive) {
      // If the option is exclusive and already selected, deselect it
      if (selectedOptions.some((item) => item.value === option.value)) {
        setSelectedOptions([]);
        setCheckOptSave([]);
      } else {
        // If the option is exclusive and not selected, select it and deselect others
        setSelectedOptions([option]);
        setCheckOptSave([option]);
      }
    } else {
      // For non-exclusive options, handle the checkbox change as before
      if (selectedOptions.some((item) => item.value === option.value)) {
        setSelectedOptions(
          selectedOptions.filter((item) => item.value !== option.value)
        );
        setCheckOptSave(
          selectedOptions.filter((item) => item.value !== option.value)
        );
      } else {
        if (selectedOptions.some((item) => item.isExclusive)) {
          setSelectedOptions([option]);
          setCheckOptSave([option]);
        } else {
          setSelectedOptions([...selectedOptions, option]);
          setCheckOptSave([...selectedOptions, option]);
        }
      }
    }
  };

  const prevCheckOptSave = useRef(checkOptSave);

  useEffect(() => {
    const savedAnswer =
      selectedOptions.length > 0
        ? selectedOptions.map((item) => item?.value).join("|") + "|"
        : "";
    if (checkOptSave !== prevCheckOptSave.current) {
      onChange(savedAnswer);
      prevCheckOptSave.current = checkOptSave;
    }
  }, [checkOptSave]);

  useEffect(() => {
    const resultArray = value
      ?.split("|")
      .filter((item) => item !== null && item !== undefined && item !== "");
    let options = resultArray?.map((opt) => {
      const filteredArray = checkOptions.find((item) => item?.value === opt);
      return filteredArray;
    });
    setSelectedOptions(options);
  }, [value, checkOptions]);

  const groupedOptions = checkOptions.reduce((acc, option) => {
    const col = option.columnNo;
    if (!acc[col]) acc[col] = [];
    acc[col].push(option);
    return acc;
  }, {});

  const columnNos = Object.keys(groupedOptions)
    .map(Number)
    .sort((a, b) => a - b);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        paddingX: "15px",
      }}
    >
      <FormControl component="fieldset">
        <FormGroup
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            flexWrap: "nowrap",
          }}
        >
          {columnNos.map((col) => (
            <Box
              key={col}
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {groupedOptions[col]?.map((option) => {
                return (
                  <Box
                    key={option.val}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex start",
                      marginRight: 1,
                    }}
                  >
                    <FormControlLabel
                      key={option.value}
                      disabled={type === "preview" || disabledField}
                      control={
                        <Checkbox
                          onChange={(event) => handleChange(event, option)}
                          historicalVal={option?.historicalAnswer?.includes(
                            option.value
                          )}
                          value={option.value}
                          checked={selectedOptions?.some(
                            (item) => item?.value === option?.value
                          )}
                        />
                      }
                      label={
                        <>
                          {errorIndicator?.displayIndicator && (
                            <span style={{ color: "maroon" }}>{`<< `}</span>
                          )}
                          {htmlParser(option.label)}
                        </>
                      }
                    />
                    {option.dependentField && renderDependentField?.()}
                  </Box>
                );
              })}
            </Box>
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
};

export default MultipleChoiceQuestion;
